import { Capacitor } from "@capacitor/core";
import { onMounted } from "vue";

/**
 * Set the status bar text style for the current page.
 * The status bar is globally transparent (overlay mode set in vue.js).
 * Use this to switch between dark/light text per page.
 *
 * @param style - "Light" (dark text on light bg) or "Dark" (light text on dark bg). Default: "Light"
 */
export function useStatusBar(style: "Light" | "Dark" = "Light") {
    if (!Capacitor.isNativePlatform()) {
        return;
    }

    onMounted(async () => {
        try {
            const { StatusBar, Style } = await import("@capacitor/status-bar");
            await StatusBar.setStyle({ style: style === "Dark" ? Style.Dark : Style.Light });
        } catch {
            // Status bar plugin unavailable — non-critical, ignore
        }
    });
}
